import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InvoiceShow from './InvoiceShow';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import { compose } from 'recompose';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { connect } from 'react-redux';
import { fetchInvoices } from 'store/actions/invoices/fetchInvoices';
import { fetchUser } from 'store/actions/users/fetchUsers';
import utils from 'helpers/utils';

class InvoiceShowContainer extends Component {
    componentDidUpdate(prevProps) {
        const { data, fetchUser } = this.props;

        const diffData = utils.diffObjects(prevProps.data, data);

        if (!utils.isEmpty(diffData) && diffData.user_id) {
            fetchUser({ id: data.user_id });
        }
    }

    render() {
        const {
            data,
            id,
            resourceFetchFailed,
            resourceFetchLoading,
            user,
        } = this.props;

        if (resourceFetchLoading || user === undefined) {
            return <LoadingCard />;
        }

        if (resourceFetchFailed) {
            return <ResourceNotFound />;
        }

        return <InvoiceShow data={ data } id={ id } user={ user } />;
    }
}

InvoiceShowContainer.propTypes = {
    data: PropTypes.object,
    fetchUser: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    resourceFetchFailed: PropTypes.bool,
    resourceFetchLoading: PropTypes.bool,
    user: PropTypes.object,
};

const mapStateToProps = (state, props) => {
    const { data } = props;

    const user = data && state.users.data
        ? state.users.data[data.user_id] || null
        : undefined;

    return { user };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchUser: (payload) => {
            dispatch(fetchUser(payload));
        },
    };
};

const enhance = compose(
    fetchResourceById({
        action: fetchInvoices,
        resource: 'invoices',
    }),
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(InvoiceShowContainer);



// WEBPACK FOOTER //
// ./src/pages/invoices/show/InvoiceShowContainer.js